import "./MsActivationLinkExpired.css";
import { useConfig } from "../../contexts/ConfigContext";

function ActivationLinkExpired() {
  const { config } = useConfig();
  const bambora_url = config?.reportalLoginUrlMS1;
  return (
    <div className="activation-expired-root">
      <div className="activation-expired-content">
        <img src="/ciam/v1/static/images/ms/Broken_link.svg" alt="Broken" />
        <div>
          <h1 className="activation-expired-title">Link has expired</h1>

          <p className="activation-expired-text">
            This link has expired. To activate your account, please visit{" "}
            <a href={bambora_url} target="_blank" rel="noopener noreferrer">
              reports.bambora.com
            </a>
            , enter your email and click &quot;Forgot password&quot; and follow the instructions.
          </p>
        </div>

        <div className="activation-expired-footer">
          <img src="/ciam/v1/static/images/ms/Worldline-Mint-Horizontal.svg" alt="Worldline" />
        </div>
      </div>
    </div>
  );
}

export default ActivationLinkExpired;
